import React from 'react';
import { CheckIcon, GaugeIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { IndustrialBackdrop } from './ui/IndustrialBackdrop';
import { checkoutUrl, productBrand, productEdition } from '../data/offer';
const assurances = ['7-day guarantee', 'Secure payment', 'Instant access'];
export function FinalCta() {
  return <section className="relative isolate overflow-hidden border-t border-slate-700/60 bg-slate-900 py-16 sm:py-20" aria-labelledby="final-title" data-id="element-63" data-mp="15bspxpyucoob">
      <IndustrialBackdrop opacity="soft" data-id="element-64" data-mp="1eebkznwdxx00" />
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-65" data-mp="1edipxk6sgvxp">
        <h2 id="final-title" className="text-balance text-3xl font-extrabold uppercase tracking-tight text-white sm:text-4xl" data-id="element-66" data-mp="1t3g7hha7qndx">
          <span className="inline-flex items-center gap-2" data-id="element-67" data-mp="1o56ad14xhcpo">
            <GaugeIcon className="h-8 w-8 shrink-0 text-amber-400" aria-hidden="true" data-id="element-68" data-mp="223d0tw7jsafb" /> {productBrand}
          </span>
          <span className="mt-2 block text-xl font-extrabold uppercase tracking-[.16em] text-amber-400 sm:text-2xl" data-id="element-69" data-mp="1x5b6ug8l2qp2">
            {productEdition}
          </span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-slate-300" data-id="element-70" data-mp="s4p8zfzqjy6o">
          Created for maintenance, mechanical and plant professionals worldwide.
        </p>

        <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-8 w-full sm:w-auto" data-id="element-71" data-mp="x5v41kgvbxjd">
          Get my professional edition now
        </Button>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-slate-300" data-id="element-72" data-mp="163xboiv3xofm">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-73" data-mp="1fu9uo6n9x9jn">
              <CheckIcon className="h-4 w-4 text-blue-300" aria-hidden="true" data-id="element-74" data-mp="1fwcvzmtvmp3o" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}